var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "plate-box" },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "form bg-set",
          attrs: { model: _vm.form, rules: _vm.rules },
        },
        [
          ["category", "children"].includes(_vm.source)
            ? _c(
                "div",
                { staticClass: "pageTitle" },
                [
                  _c("div", { staticClass: "title" }, [_vm._v("页面名称")]),
                  _c("div", { staticClass: "tips2" }, [
                    _vm._v(" " + _vm._s(_vm.tips2) + " "),
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "home_index_name" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          size: "small",
                          maxlength: "10",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.form.home_index_name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "home_index_name", $$v)
                          },
                          expression: "form.home_index_name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.source === "category"
            ? _c(
                "div",
                { staticClass: "pageTitle" },
                [
                  _c("div", { staticClass: "title" }, [_vm._v("页面展示逻辑")]),
                  _c("div", { staticClass: "tips2" }, [
                    _vm._v(
                      " 选择「跟风格设置页保持一致」表示展示逻辑跟商城首页一致；选择「独立设置，先登录后展示」表示登录后才能查看； 选择「独立设置，先展示后登录」表示支持免登录查看。 "
                    ),
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { prop: "home_show_mode" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.form.home_show_mode,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "home_show_mode", $$v)
                            },
                            expression: "form.home_show_mode",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 3 } }, [
                            _vm._v("跟风格设置页保持一致"),
                          ]),
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("独立设置，先登录后展示"),
                          ]),
                          _c("el-radio", { attrs: { label: 2 } }, [
                            _vm._v("独立设置，先展示后登录"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c("div", { staticClass: "pageTitle" }, [
            _c("div", { staticClass: "title" }, [_vm._v("页面背景设置")]),
          ]),
          _c(
            "el-form-item",
            { attrs: { prop: "background_type" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.background_type,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "background_type", $$v)
                    },
                    expression: "form.background_type",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [_vm._v("背景图片")]),
                  _c("el-radio", { attrs: { label: 2 } }, [_vm._v("纯色背景")]),
                ],
                1
              ),
            ],
            1
          ),
          _vm.form.background_type == 1
            ? _c(
                "div",
                { staticClass: "bg-wrap" },
                [
                  _c(
                    "el-form-item",
                    { staticClass: "item", attrs: { prop: "top_background" } },
                    [
                      _c("div", [_vm._v("页面头部背景图(Banner轮播图区域)")]),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            color: "#999999",
                            "margin-bottom": "10px",
                          },
                        },
                        [_vm._v(" 图片尺寸为750*420，大小在1M及以内 ")]
                      ),
                      _c("div", { staticClass: "upload-wrap" }, [
                        _c(
                          "div",
                          { staticClass: "left" },
                          [
                            _c("upload-file", {
                              ref: "uploadBanner1",
                              attrs: {
                                "link-url": _vm.linkUrl,
                                tempurl: _vm.form.top_background,
                                uploadInfo: _vm.uploadInfo,
                              },
                              on: {
                                emitUploadFile: function (url) {
                                  return _vm.emitUploadFile(
                                    "top_background",
                                    url
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "right" }, [
                          _c(
                            "div",
                            { staticStyle: { "margin-bottom": "10px" } },
                            [
                              _c(
                                "el-button",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.delImg("top_background")
                                    },
                                  },
                                },
                                [_vm._v("删除图片")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.upload(1)
                                    },
                                  },
                                },
                                [_vm._v("上传图片")]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "item center",
                      attrs: { prop: "middle_background" },
                    },
                    [
                      _c("div", [
                        _vm._v(" 页面中部背景图 "),
                        _c("span", { staticClass: "tips" }, [
                          _vm._v(
                            " (轮播图下面部分，会随页面延伸，不配头部或底部背景图时，中部背景图延伸填充) "
                          ),
                        ]),
                      ]),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            color: "#999999",
                            "margin-bottom": "10px",
                          },
                        },
                        [_vm._v(" 图片尺寸为750*1，大小在1M及以内 ")]
                      ),
                      _c("div", { staticClass: "upload-wrap" }, [
                        _c(
                          "div",
                          { staticClass: "left" },
                          [
                            _c("upload-file", {
                              ref: "uploadBanner2",
                              attrs: {
                                "link-url": _vm.linkUrl,
                                tempurl: _vm.form.middle_background,
                                uploadInfo: _vm.uploadInfo,
                              },
                              on: {
                                emitUploadFile: function (url) {
                                  return _vm.emitUploadFile(
                                    "middle_background",
                                    url
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "right" }, [
                          _c(
                            "div",
                            { staticStyle: { "margin-bottom": "10px" } },
                            [
                              _c(
                                "el-button",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.delImg("middle_background")
                                    },
                                  },
                                },
                                [_vm._v("删除图片")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.upload(2)
                                    },
                                  },
                                },
                                [_vm._v("上传图片")]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "item",
                      attrs: { prop: "bottom_background" },
                    },
                    [
                      _c("div", [_vm._v("页面底部背景图")]),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            color: "#999999",
                            "margin-bottom": "10px",
                          },
                        },
                        [_vm._v(" 图片尺寸为750*100，大小在1M及以内 ")]
                      ),
                      _c("div", { staticClass: "upload-wrap" }, [
                        _c(
                          "div",
                          { staticClass: "left" },
                          [
                            _c("upload-file", {
                              ref: "uploadBanner3",
                              attrs: {
                                "link-url": _vm.linkUrl,
                                tempurl: _vm.form.bottom_background,
                                uploadInfo: _vm.uploadInfo,
                              },
                              on: {
                                emitUploadFile: function (url) {
                                  return _vm.emitUploadFile(
                                    "bottom_background",
                                    url
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "right" }, [
                          _c(
                            "div",
                            { staticStyle: { "margin-bottom": "10px" } },
                            [
                              _c(
                                "el-button",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.delImg("bottom_background")
                                    },
                                  },
                                },
                                [_vm._v("删除图片")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { on: { click: _vm.upload } },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.upload(3)
                                    },
                                  },
                                },
                                [_vm._v("上传图片")]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.form.background_type == 2
            ? _c(
                "div",
                { staticClass: "bg-wrap bg-wrap2" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "solid_color_background" } },
                    [
                      _c("span", { staticClass: "label" }, [
                        _vm._v("选择颜色"),
                      ]),
                      _c("el-color-picker", {
                        attrs: {
                          "popper-class": "color_picker_popper",
                          predefine: _vm.predefine,
                        },
                        model: {
                          value: _vm.form.solid_color_background,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "solid_color_background", $$v)
                          },
                          expression: "form.solid_color_background",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.info.temp_type !== "view"
            ? _c(
                "div",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.toSave } },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.source === "template" ? "完成" : "保存") +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm.source === "home"
        ? [
            _c("el-divider"),
            _c(
              "el-form",
              {
                ref: "headerForm",
                staticClass: "form header-set",
                attrs: {
                  "label-width": "120px",
                  model: _vm.headerForm,
                  rules: _vm.headerRules,
                },
              },
              [
                _c("div", { staticClass: "pageTitle" }, [
                  _c("div", { staticClass: "title" }, [
                    _vm._v("小程序-商城头部配置"),
                  ]),
                ]),
                _c(
                  "el-form-item",
                  { attrs: { label: "头部展示方式", prop: "header_style" } },
                  [
                    _c(
                      "div",
                      { staticClass: "header_style" },
                      _vm._l(_vm.headerList, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: item.id,
                            class: [
                              "item",
                              item.id == _vm.headerForm.header_style &&
                                "active",
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.changeProps(
                                  _vm.headerForm,
                                  "header_style",
                                  item.id
                                )
                              },
                            },
                          },
                          [
                            _c("el-image", {
                              staticClass: "img",
                              attrs: { src: item.image_url },
                            }),
                            _c("div", { staticClass: "btm-wrap" }, [
                              _c("div", { staticClass: "btm-name" }, [
                                _vm._v(_vm._s(item.name)),
                              ]),
                              _c("div", { staticClass: "btm-btn-wrap" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "preview",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.showPreviewList(index)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(" 预览"),
                                    _c("i", {
                                      staticClass: "el-icon el-icon-view",
                                    }),
                                  ]
                                ),
                                _c("div", { staticClass: "select" }, [
                                  _vm._v(" 选择 "),
                                  _c("i", {
                                    class: [
                                      "icon",
                                      item.id == _vm.headerForm.header_style
                                        ? "el-icon-success"
                                        : "no-check",
                                    ],
                                  }),
                                ]),
                              ]),
                            ]),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ]
                ),
                _vm.headerForm.header_style == 1
                  ? [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "title_name",
                          attrs: { label: "商城首页标题", prop: "title_name" },
                        },
                        [
                          ["plat_custom", "custom"].includes(_vm.info.module)
                            ? _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "请选择" },
                                  on: {
                                    change: function (val) {
                                      return _vm.changeTitleType(val, "title")
                                    },
                                  },
                                  model: {
                                    value: _vm.headerForm.title_type,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.headerForm,
                                        "title_type",
                                        $$v
                                      )
                                    },
                                    expression: "headerForm.title_type",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "渠道标题", value: 1 },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "自定义标题", value: 2 },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c("el-input", {
                            staticClass: "input",
                            attrs: {
                              placeholder: "请输入",
                              clearable: "",
                              "show-word-limit": "",
                              maxlength: "10",
                              disabled:
                                ["plat_custom", "custom"].includes(
                                  _vm.info.module
                                ) && _vm.headerForm.title_type == 1,
                            },
                            model: {
                              value: _vm.headerForm.title_name,
                              callback: function ($$v) {
                                _vm.$set(_vm.headerForm, "title_name", $$v)
                              },
                              expression: "headerForm.title_name",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "首页标题颜色", prop: "title_color" },
                        },
                        [
                          _c("el-color-picker", {
                            model: {
                              value: _vm.headerForm.title_color,
                              callback: function ($$v) {
                                _vm.$set(_vm.headerForm, "title_color", $$v)
                              },
                              expression: "headerForm.title_color",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "展示位置", prop: "title_position" },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.headerForm.title_position,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.headerForm,
                                    "title_position",
                                    $$v
                                  )
                                },
                                expression: "headerForm.title_position",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "left" } }, [
                                _vm._v("居左"),
                              ]),
                              _c("el-radio", { attrs: { label: "center" } }, [
                                _vm._v("居中"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  : _vm._e(),
                _vm.headerForm.header_style == 2
                  ? [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "logo_imageurl",
                          attrs: {
                            label: "商城首页logo",
                            prop: "logo_imageurl",
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "content" },
                            [
                              ["plat_custom", "custom"].includes(
                                _vm.info.module
                              )
                                ? _c(
                                    "el-select",
                                    {
                                      attrs: { placeholder: "请选择" },
                                      on: {
                                        change: function (val) {
                                          return _vm.changeTitleType(
                                            val,
                                            "logo"
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.headerForm.logo_type,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.headerForm,
                                            "logo_type",
                                            $$v
                                          )
                                        },
                                        expression: "headerForm.logo_type",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: { label: "渠道LOGO", value: 1 },
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: "自定义LOGO",
                                          value: 2,
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c("upload-file", {
                                ref: "uploadBannerHeader",
                                attrs: {
                                  "link-url": _vm.linkUrl,
                                  tempurl: _vm.headerForm.logo_imageurl,
                                  canDel:
                                    Boolean(_vm.headerForm.logo_imageurl) &&
                                    !(
                                      ["plat_custom", "custom"].includes(
                                        _vm.info.module
                                      ) && _vm.headerForm.logo_type == 1
                                    ),
                                  uploadInfo: _vm.uploadInfo,
                                  disabled:
                                    ["plat_custom", "custom"].includes(
                                      _vm.info.module
                                    ) && _vm.headerForm.logo_type == 1,
                                },
                                on: {
                                  emitUploadFile: function (url) {
                                    _vm.headerForm.logo_imageurl =
                                      "" + _vm.$ossurl + url
                                  },
                                  onDelete: _vm.deleteLogo,
                                },
                              }),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    disabled:
                                      ["plat_custom", "custom"].includes(
                                        _vm.info.module
                                      ) && _vm.headerForm.logo_type == 1,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.upload("Header")
                                    },
                                  },
                                },
                                [_vm._v("上传图片")]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "标题展示位置",
                            prop: "logo_position",
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              on: {
                                change: function ($event) {
                                  return _vm.changeProps(
                                    _vm.headerForm,
                                    "logo_position",
                                    $event
                                  )
                                },
                              },
                              model: {
                                value: _vm.headerForm.logo_position,
                                callback: function ($$v) {
                                  _vm.$set(_vm.headerForm, "logo_position", $$v)
                                },
                                expression: "headerForm.logo_position",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: "left" } }, [
                                _vm._v("居左"),
                              ]),
                              _c("el-radio", { attrs: { label: "center" } }, [
                                _vm._v("居中"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.headerForm.logo_position === "left"
                        ? [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "头部导航",
                                  prop: "header_nav",
                                },
                              },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    model: {
                                      value: _vm.headerForm.header_nav,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.headerForm,
                                          "header_nav",
                                          $$v
                                        )
                                      },
                                      expression: "headerForm.header_nav",
                                    },
                                  },
                                  [
                                    _c("el-radio", { attrs: { label: 2 } }, [
                                      _vm._v("开启"),
                                    ]),
                                    _c("el-radio", { attrs: { label: 1 } }, [
                                      _vm._v("关闭"),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm.headerForm.header_nav === 2
                              ? [
                                  _vm._l(
                                    _vm.headerForm.header_nav_config,
                                    function (item, index) {
                                      return _c(
                                        "div",
                                        { key: index },
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                prop:
                                                  "header_nav_config." +
                                                  index +
                                                  ".name",
                                                label:
                                                  "菜单" +
                                                  { 0: "一", 1: "二" }[index],
                                                rules: [
                                                  {
                                                    required: true,
                                                    max: 6,
                                                    message:
                                                      "菜单名称应为1-6个字符",
                                                  },
                                                ],
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                staticClass: "input",
                                                attrs: {
                                                  clearable: "",
                                                  placeholder: "菜单名称",
                                                },
                                                model: {
                                                  value: item.name,
                                                  callback: function ($$v) {
                                                    _vm.$set(item, "name", $$v)
                                                  },
                                                  expression: "item.name",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          !item.is_home
                                            ? [
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    attrs: {
                                                      prop:
                                                        "header_nav_config." +
                                                        index +
                                                        ".link_type",
                                                      rules: [
                                                        {
                                                          required: true,
                                                          message:
                                                            "菜单类型不可为空",
                                                          trigger: "change",
                                                        },
                                                      ],
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "el-select",
                                                      {
                                                        staticClass: "input",
                                                        attrs: {
                                                          placeholder:
                                                            "请选择菜单类型",
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.changeProps(
                                                              item,
                                                              "link_value",
                                                              ""
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value: item.link_type,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "link_type",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.link_type",
                                                        },
                                                      },
                                                      [
                                                        _c("el-option", {
                                                          attrs: {
                                                            label: "选菜单",
                                                            value: "1",
                                                          },
                                                        }),
                                                        _c("el-option", {
                                                          attrs: {
                                                            label: "子页面",
                                                            value: "3",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "el-form-item",
                                                  {
                                                    attrs: {
                                                      prop:
                                                        "header_nav_config." +
                                                        index +
                                                        ".link_value",
                                                      rules: [
                                                        {
                                                          required: true,
                                                          message:
                                                            "选项不可为空",
                                                          trigger: "change",
                                                        },
                                                      ],
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "el-select",
                                                      {
                                                        staticClass: "input",
                                                        attrs: {
                                                          placeholder:
                                                            item.link_type ===
                                                            "1"
                                                              ? "请选择菜单链接"
                                                              : item.link_type ===
                                                                "3"
                                                              ? "请选择子页面"
                                                              : "请先选择菜单类型",
                                                          filterable: "",
                                                        },
                                                        model: {
                                                          value:
                                                            item.link_value,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              item,
                                                              "link_value",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "item.link_value",
                                                        },
                                                      },
                                                      [
                                                        item.link_type === "1"
                                                          ? _vm._l(
                                                              _vm.menuList,
                                                              function (menu) {
                                                                return _c(
                                                                  "el-option",
                                                                  {
                                                                    key: menu.id,
                                                                    attrs: {
                                                                      label:
                                                                        menu.show_name,
                                                                      value:
                                                                        menu.id,
                                                                      disabled:
                                                                        menu.disabled,
                                                                    },
                                                                  }
                                                                )
                                                              }
                                                            )
                                                          : _vm._e(),
                                                        item.link_type === "3"
                                                          ? _vm._l(
                                                              _vm.childrenMenuList,
                                                              function (
                                                                childMenu,
                                                                child_index
                                                              ) {
                                                                return _c(
                                                                  "el-option",
                                                                  {
                                                                    key: child_index,
                                                                    attrs: {
                                                                      label:
                                                                        childMenu.name +
                                                                        "（" +
                                                                        childMenu.id +
                                                                        "）",
                                                                      value:
                                                                        childMenu.page_unique_key,
                                                                      disabled:
                                                                        childMenu.status +
                                                                          "" !==
                                                                        "0",
                                                                    },
                                                                  }
                                                                )
                                                              }
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      2
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            : _vm._e(),
                                        ],
                                        2
                                      )
                                    }
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: "按钮主题颜色",
                                        prop: "header_nav_button_color",
                                      },
                                    },
                                    [
                                      _c("el-color-picker", {
                                        model: {
                                          value:
                                            _vm.headerForm
                                              .header_nav_button_color,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.headerForm,
                                              "header_nav_button_color",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "headerForm.header_nav_button_color",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              : _vm._e(),
                          ]
                        : _vm._e(),
                    ]
                  : _vm._e(),
                _vm.info.temp_type !== "view"
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              loading: _vm.headerLoading,
                            },
                            on: { click: _vm.saveHeader },
                          },
                          [_vm._v(" 保存 ")]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              2
            ),
          ]
        : _vm._e(),
      [
        _c("el-divider"),
        _c(
          "el-form",
          {
            ref: "borderForm",
            staticClass: "form header-set border-set",
            attrs: {
              "label-width": "120px",
              model: _vm.borderForm,
              rules: _vm.borderRules,
              disabled: _vm.borderFormDisabled,
            },
          },
          [
            _c("div", { staticClass: "pageTitle" }, [
              _c("div", { staticClass: "title" }, [_vm._v("页面边框设置")]),
            ]),
            _c(
              "el-form-item",
              { attrs: { label: "圆角类型", prop: "type" } },
              [
                _c(
                  "el-radio-group",
                  {
                    attrs: { size: "medium" },
                    model: {
                      value: _vm.borderForm.type,
                      callback: function ($$v) {
                        _vm.$set(_vm.borderForm, "type", $$v)
                      },
                      expression: "borderForm.type",
                    },
                  },
                  [
                    _c("el-radio-button", { attrs: { label: 1 } }, [
                      _c("i", {
                        staticClass:
                          "custom-icon custom-icon-yuanjiaofangkuang",
                      }),
                      _vm._v(" 全角弧度 "),
                    ]),
                    _c("el-radio-button", { attrs: { label: 2 } }, [
                      _c("i", {
                        staticClass: "custom-icon custom-icon-radius-upright",
                      }),
                      _vm._v(" 独立圆角"),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.borderForm.type === 1
              ? _c(
                  "el-form-item",
                  { attrs: { label: "圆角弧度", prop: "broder_general" } },
                  [
                    _c(
                      "el-input",
                      {
                        staticClass: "input",
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.borderForm.broder_general,
                          callback: function ($$v) {
                            _vm.$set(_vm.borderForm, "broder_general", $$v)
                          },
                          expression: "borderForm.broder_general",
                        },
                      },
                      [_c("template", { slot: "append" }, [_vm._v("px")])],
                      2
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.borderForm.type === 2
              ? _c(
                  "div",
                  { staticClass: "border-box" },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "左上角",
                          "label-width": "70px",
                          prop: "broder_left_top",
                        },
                      },
                      [
                        _c(
                          "el-input",
                          {
                            staticClass: "input",
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.borderForm.broder_left_top,
                              callback: function ($$v) {
                                _vm.$set(_vm.borderForm, "broder_left_top", $$v)
                              },
                              expression: "borderForm.broder_left_top",
                            },
                          },
                          [_c("template", { slot: "append" }, [_vm._v("px")])],
                          2
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "右上角",
                          "label-width": "70px",
                          prop: "broder_right_top",
                        },
                      },
                      [
                        _c(
                          "el-input",
                          {
                            staticClass: "input",
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.borderForm.broder_right_top,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.borderForm,
                                  "broder_right_top",
                                  $$v
                                )
                              },
                              expression: "borderForm.broder_right_top",
                            },
                          },
                          [_c("template", { slot: "append" }, [_vm._v("px")])],
                          2
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "左下角",
                          "label-width": "70px",
                          prop: "broder_left_bottom",
                        },
                      },
                      [
                        _c(
                          "el-input",
                          {
                            staticClass: "input",
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.borderForm.broder_left_bottom,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.borderForm,
                                  "broder_left_bottom",
                                  $$v
                                )
                              },
                              expression: "borderForm.broder_left_bottom",
                            },
                          },
                          [_c("template", { slot: "append" }, [_vm._v("px")])],
                          2
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "右下角",
                          "label-width": "70px",
                          prop: "broder_right_bottom",
                        },
                      },
                      [
                        _c(
                          "el-input",
                          {
                            staticClass: "input",
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.borderForm.broder_right_bottom,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.borderForm,
                                  "broder_right_bottom",
                                  $$v
                                )
                              },
                              expression: "borderForm.broder_right_bottom",
                            },
                          },
                          [_c("template", { slot: "append" }, [_vm._v("px")])],
                          2
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _vm.info.temp_type !== "view"
          ? _c(
              "div",
              [
                _vm.borderFormDisabled
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            _vm.borderFormDisabled = false
                          },
                        },
                      },
                      [_vm._v(" 编辑 ")]
                    )
                  : [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.saveBorder },
                        },
                        [_vm._v(" 保存 ")]
                      ),
                      _c("el-button", { on: { click: _vm.cancelBorder } }, [
                        _vm._v(" 取消 "),
                      ]),
                    ],
              ],
              2
            )
          : _vm._e(),
      ],
      _vm.showViewer
        ? _c("image-viewer", {
            attrs: {
              "on-close": _vm.closeViewer,
              "url-list": _vm.previewSrcList,
              zoomRate: 0.05,
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }